export type NonEmptyArray<T> = [T, ...T[]];

export const shuffleArray = <T>(originalArray: T[]): T[] => {
  const arrayToShuffle = [...originalArray];

  for (let i = arrayToShuffle.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = arrayToShuffle[i];
    arrayToShuffle[i] = arrayToShuffle[j];
    arrayToShuffle[j] = temp;
  }

  return arrayToShuffle;
};
